import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditAdittionalInformationPage } from './edit-additional-information.page';

const routes: Routes = [
  { path: '', component: EditAdittionalInformationPage }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EditAdittionalInformationRoutingModule { }
